import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { emailTemplatesApi } from '@/lib/api';

export function useEmailTemplates() {
  return useQuery({
    queryKey: ['email-templates'],
    queryFn: emailTemplatesApi.list,
  });
}

export function useEmailEvents() {
  return useQuery({
    queryKey: ['email-templates', 'events'],
    queryFn: emailTemplatesApi.listEvents,
  });
}

export function useEmailTemplate(event: string | undefined) {
  return useQuery({
    queryKey: ['email-templates', event],
    queryFn: () => emailTemplatesApi.getByEvent(event!),
    enabled: !!event,
  });
}

export function useUpdateEmailTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ event, data }: { event: string; data: Parameters<typeof emailTemplatesApi.update>[1] }) =>
      emailTemplatesApi.update(event, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['email-templates'] });
    },
  });
}

export function useResetEmailTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (event: string) => emailTemplatesApi.resetToDefault(event),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['email-templates'] });
    },
  });
}
